import React from 'react'
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom'
import { PERSONAL_ROUTES } from 'client-portal/constants/routes'
import { PersonalTests } from 'client-portal/routes/PersonalTests'
import { PersonalTestSessions } from 'client-portal/routes/PersonalTestSessions'
import { PersonalTestSessionDetails } from 'client-portal/routes/PersonalTestSessionDetails'
import { UserSettings } from 'client-portal/routes/UserSettings'
import { Questionnaire } from 'client-portal/routes/Questionnaire'
import { Vaccine } from 'client-portal/routes/Vaccine'
import { useAuth, UserRole, useCompanyMember, CompanyIsAllowed } from '@modmd/data'

export const PersonalRoutes: React.VFC<RouteComponentProps> = ({ match }) => {
  const auth = useAuth()
  const { hasRoles } = useAuth()
  const isSuperAdmin = hasRoles([UserRole.SUPER_ADMIN])
  const isCLS = hasRoles([UserRole.CLS])
  const { data: isCompanyAllowed } = useCompanyMember({
    userId: auth.data.User.id,
  }) as CompanyIsAllowed

  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/${PERSONAL_ROUTES.SESSIONS}/:testSessionId`}
        component={PersonalTestSessionDetails}
      />
      <Route path={`${match.url}/${PERSONAL_ROUTES.TESTS}`} component={PersonalTests} />
      <Route path={`${match.url}/${PERSONAL_ROUTES.SESSIONS}`} component={PersonalTestSessions} />
      {(isSuperAdmin || isCompanyAllowed?.companyMember || isCLS) && (
        <Route path={`${match.url}/${PERSONAL_ROUTES.VACCINES}`} component={Vaccine} />
      )}
      {(isSuperAdmin || isCompanyAllowed?.companyMember || isCLS) && (
        <Route path={`${match.url}/${PERSONAL_ROUTES.QUESTIONNAIRE}`} component={Questionnaire} />
      )}
      <Route
        exact
        path={[
          `${match.url}/${PERSONAL_ROUTES.SETTINGS}`,
          `${match.url}/${PERSONAL_ROUTES.SETTINGS_GENERAL}`,
          `${match.url}/${PERSONAL_ROUTES.SETTINGS_VACCINE_RECORD}`,
          `${match.url}/${PERSONAL_ROUTES.SETTINGS_INSURANCE}`,
          `${match.url}/${PERSONAL_ROUTES.SETTINGS_CHANGE_PASSWORD}`,
          `${match.url}/${PERSONAL_ROUTES.SETTINGS_BILLING}`,
          `${match.url}/${PERSONAL_ROUTES.SETTINGS_DELETE_PROFILE}`,
          `${match.url}/${PERSONAL_ROUTES.SETTINGS_NOTIFICATIONS}`,
        ]}
        component={UserSettings}
      />
      <Redirect to={`${match.url}/${PERSONAL_ROUTES.SESSIONS}`} />
    </Switch>
  )
}
